import { lazy } from "react";

const CHUNK_RELOAD_KEY = "chunk_reload_once";

/**
 * Wrap React.lazy imports so a stale dev-server chunk (ChunkLoadError)
 * triggers one automatic full reload instead of a blank error screen.
 */
export default function lazyRetry(importFn) {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (error) {
      const message = String(error?.message || error || "");
      const isChunkError =
        error?.name === "ChunkLoadError" ||
        /Loading chunk .* failed/i.test(message) ||
        /error loading dynamically imported module/i.test(message);

      if (!isChunkError) throw error;

      const reloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
      if (!reloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
        window.location.reload();
        return { default: () => null };
      }
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      throw error;
    }
  });
}
